import React from "react";
import { SearchIcon, ChevronDown, CircleAlert } from "lucide-react";
import { Checkbox, TextField } from "@mui/material";
import ProductSection from "../ProductsModule/Components/ProductSection";
import { Permissions } from "../../../permissions";

const EditCustomer = () => {
  let blockAccouont =
    Permissions.find(permission => permission.includes("block_customer")) !==
    undefined;
  return (
    <div className=" ml-[2.083333vw] mr-[2.638888vw] bg-white  mt-[4.8vh] h-[84vh] overflow-y-scroll no-scrollbar customScrollBar ">
      <div className="bg-white rounded-xl pb-4">
        <div className="flex flex-row box-border h-[8.7vh] w-[100]">
          <div className="w-[70%] h-[100% box-border flex items-center px-[3.220338983%] justify-start text-[22px] font-medium font-outfit">
            Edit Customer
          </div>
          <div className="w-[30%] h-[100%] mt-3 box-border flex flex-row"></div>
        </div>
        <hr className=" w-[100%] mx-auto" />
        <div className="grid grid-cols-3 gap-x-3 gap-y-3 w-[90%] h-[100%] mt-[2.359259259vh] box-border px-[3.220338983%]">
          <TextField
            id="outlined-basic"
            label="First Name"
            variant="outlined"
            className="border-dotted border-2 border-green-400"
            required={true}
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="Phone"
            variant="outlined"
            required={true}
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="Whatsapp number"
            variant="outlined"
            required={true}
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="Customer Name"
            variant="outlined"
            required={true}
            size="small"
          />
        </div>

        <ProductSection data={"Shop Address*"} />

        <div className="grid grid-cols-4 gap-x-3 gap-y-3 w-[90%] h-[100%] mt-[1.959259259vh] box-border px-[3.220338983%]">
          <TextField
            id="outlined-basic"
            label="Shop no."
            variant="outlined"
            className="border-dotted border-2 border-green-400"
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="Area"
            variant="outlined"
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="City"
            variant="outlined"
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="State"
            variant="outlined"
            size="small"
          />
        </div>

        <ProductSection data={"Delivery Address*"} />
        <div className="w-[50%] flex items-center mx-[2.52222vw] mt-3 justify-start flex-row">
          <Checkbox color="default" />{" "}
          <p className="font-outfit text-[18px] font-medium">
            Same as Shop Address
          </p>
        </div>

        <div className="grid grid-cols-4 gap-x-3 gap-y-3 w-[90%] h-[100%] mt-[1.959259259vh] box-border px-[3.220338983%]">
          <TextField
            id="outlined-basic"
            label="Shop no."
            variant="outlined"
            className="border-dotted border-2 border-green-400"
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="Area"
            variant="outlined"
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="City"
            variant="outlined"
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="State"
            variant="outlined"
            size="small"
          />
        </div>

        <ProductSection data={"Documents"} />

        <div className="grid grid-cols-4 gap-x-3 gap-y-3 w-[90%] h-[100%] mt-[1.959259259vh] box-border px-[3.220338983%]">
          <TextField
            id="outlined-basic"
            label="GSTIN"
            required="true"
            variant="outlined"
            className="border-dotted border-2 border-green-400"
            size="small"
          />
          <TextField
            id="outlined-basic"
            label="Tax Payer type"
            variant="outlined"
            required="true"
            size="small"
          />
        </div>

        <ProductSection data={"file upload (gst certificate, business PAN)"} />

        <div className="bg-white rounded-xl mt-[3.5185vh] mx-[1.4vw]">
          <div className="pb-10 w-[50%] ">
            <div className="flex flex-row gap-x-[10.27%] mt-[3.6886%] ml-[3.7%]  font-outfit font-normal items-center justify-start">
              <p>GST Certificate:</p>{" "}
              <p>
                gstcertificate.pdf{" "}
                <button className="bg-zinc-200 border-2 border-[#FF0000] py-2 rounded-xl mx-4 px-8">
                  Delete
                </button>{" "}
              </p>
            </div>
            <div className="flex flex-row gap-x-[6.97%] mt-[1.6886%] ml-[3.7%]  font-outfit font-normal items-center justify-start">
              <p>Buisness PAN:</p>{" "}
              <p>
                {" "}
                <button className="bg-zinc-200 border-2 border-zinc-100 py-2 rounded-xl px-4">
                  Choose file
                </button>{" "}
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-start mx-[2.2vw]">
          <TextField
            id="outlined-basic"
            label="Credit Limit"
            variant="outlined"
            required="true"
            size="small"
          />
        </div>

        <ProductSection data={"Brand Visibility"} />

        <div className="flex flex-row box-border h-[8.7vh] w-[100]">
          <div className="w-[50%] flex items-center mx-[2.52222vw] mt-3 justify-start flex-row">
            <Checkbox color="default" />{" "}
            <p className="font-outfit text-[20px] font-medium">
              Select all brands
            </p>
          </div>
          <div className="w-[60%] h-[100%] mt-3 box-border flex flex-row">
            <div className=" flex flex-row space-x-4">
              <span className="font-outfit font-medium text-[14px] cursor-pointer h-[60%] flex items-center justify-center underline text-[#5652B0]">
                View all
              </span>
              <span className="font-outfit font-medium text-[14px] cursor-pointer flex h-[60%] items-center justify-center underline ">
                View Selected
              </span>
              <span className="font-outfit font-medium text-[14px] cursor-pointer h-[60%] flex items-center justify-center underline">
                View Unselected
              </span>
              <div className="bg-[#F5F6F8] rounded-lg flex  flex-row items-center border border-grey-400 h-[65%] allProductSearchBoxContainer">
                <SearchIcon
                  className=" mx-2 w-[20px] h-[20px]"
                  color="#83899F"
                />
                <input
                  type="text"
                  placeholder="Search by Name..."
                  className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-5 gap-x-3 gap-y-4 w-[92%] mx-auto h-[30vh] overflow-scroll border-2 border-zinc-200 p-3 rounded-xl ">
          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>

          <div className=" flex items-center justify-start flex-row">
            <div className="bg-[#6750A414] w-[40px] rounded-full mx-2 h-[40px]">
              <Checkbox color="default" />
            </div>{" "}
            <p className="font-outfit text-[18px] font-medium">Snketchers</p>
          </div>
        </div>

        <div className="w-[100%] box-border flex flex-row mt-[3.5185vh] ml-[0.283333vw] mr-[2.638888vw] ">
          <div className=" flex flex-row space-x-9 ">
            <span className="font-outfit font-medium text-[3.2967678vh] ml-[2vw] mb-2 cursor-pointer flex items-center justify-center text-[#333333]">
              Action
            </span>
          </div>
        </div>

        <div className="bg-white rounded-xl">
          <p className="flex flex-row pb-2 border-b-2 border-zinc-300 rounded-md w-[100%] mx-auto">
            <span className="w-[80%] flex items-senter ml-[3.3%] mt-[1.7%] text-[2.81vh] font-normal font-outfit h-[5.5vh]">
              Block Account
            </span>{" "}
            <span className="flex items-center justify-end w-[20%] px-3">
              {blockAccouont ? (
                <span className="w-[100%] items-center justify-start flex px-2 text-[2.1vh] font-outfit font-medium text-[#4A504B] mx-1">
                  <button className="bg-[#FF0000] py-2 rounded-md text-[14px] font-medium font-outfit flex items-center justify-center flex-row ">
                    {" "}
                    <span className="px-3 text-white flex flex-row gap-x-1">
                      block Account
                    </span>
                  </button>
                </span>
              ) : (
                <span className="w-[100%] items-center justify-start flex px-2 text-[2.1vh] font-outfit font-medium text-[#4A504B] mx-1">
                  <button className="bg-[#acacac1A] py-2 rounded-md text-[14px] font-medium font-outfit flex items-center justify-center flex-row ">
                    {" "}
                    <span className="px-3 text-black flex flex-row gap-x-1">
                      block Account
                    </span>
                  </button>
                </span>
              )}
              {"  "}
              <ChevronDown
                color="#5652B0"
                className="bg-[#F9F8FE] rounded-full p-[0.2px]"
              />
            </span>
          </p>
          <div className="pb-10">
            <div className="flex flex-row items-center w-[40%] justify-start mt-[1.6886%] ml-[3.7%]  font-outfit font-normal bg-[#EEF3F8] rounded-xl py-2">
              <CircleAlert color="#333333" className="mx-2" />
              This will prevent customer from logging in to the application.
            </div>
            <div className="flex flex-row items-center justify-start mt-[1.6886%] ml-[3.7%]  font-outfit font-normal ">
              <Checkbox color="default" />
              Confirm Blocking{" "}
              <p className="font-outfit font-medium mx-3"> Madhur Creation</p>
            </div>
          </div>
        </div>

        <div className="flex flex-row mt-9 items-start justify-start gap-x-3 mx-[2.2vw] pb-10">
          <button className="border-2 border-zinc-200 rounded-md px-9 py-2 text-[18px] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
            {" "}
            <span className="px- text-[#5652B0] px-3">Cancel</span>
          </button>
          <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[18px] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
            {" "}
            <span className="px-2 text-white ">Save</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCustomer;
